import request from '@/plugins/request';

// 登录模块

// 获取图形验证码
export function GetCaptcha(data) {
    return request({
        url: '/chainmaker?cmb=GetCaptcha',
        method: 'post',
        data
    });
}
// 登录
export function Login(data) {
    return request({
        url: '/user/login',
        method: 'post',
        data
    });
}

// 用户管理模块

// 获取用户列表
export function GetUserList(data) {
    return request({
        url: 'user/getUserInfoList',
        method: 'post',
        data
    });
}
// 新增用户
export function AddUser(data) {
    return request({
        url: '/user/addUser',
        method: 'post',
        data
    });
}

// 编辑用户
export function UpdateUser(data) {
    return request({
        url: '/user/updateUserInfo',
        method: 'post',
        data
    });
}

// 删除某一用户
export function DelUser(data) {
    return request({
        url: '/user/delUser',
        method: 'post',
        data
    });
}

// 启用账号
export function UpdateUserStatus(data) {
    return request({
        url: '/user/updateUserStatus',
        method: 'post',
        data
    });
}

// 重置密码
export function ResetPassword(data) {
    return request({
        url: '/user/resetPassword',
        method: 'post',
        data
    });
}

// 获取用户角色列表
export function GetRoleInfoList(data) {
    return request({
        url: '/user/getRoleInfoList',
        method: 'post',
        data
    });
}

// 新增角色
export function AddRole(data) {
    return request({
        url: '/user/addRole',
        method: 'post',
        data
    });
}

// 删除角色
export function DelRole(data) {
    return request({
        url: '/user/delRole',
        method: 'post',
        data
    });
}

// 新增菜单
export function AddMenu(data) {
    return request({
        url: '/user/addMenuInfo',
        method: 'post',
        data
    });
}

// 获取所有的菜单信息列表
export function GetMenuList(data) {
    return request({
        url: '/user/getMenuInfoList',
        method: 'post',
        data
    });
}

// 动态路由 - 获取用户的权限列表
export function GetRoleMenuList(data) {
    return request({
        url: '/user/getRoleMenuInfoList',
        method: 'post',
        data
    });
}

// 修改角色名称
export function UpdateRoleName(data) {
    return request({
        url: '/user/updateRoleNameInfo',
        method: 'post',
        data
    });
}

// 删除菜单
export function DelMenu(data) {
    return request({
        url: '/user/delMenuInfo',
        method: 'post',
        data
    });
}



// 更新菜单信息 - 绑定菜单所对应的按钮列表
export function UpdateMenu(data) {
    return request({
        url: "/user/updateMenu",
        method: "post",
        data
    })
}

/**
 * 权限管理 - 按钮
 */

// 根据角色ID和菜单ID，获取按钮权限
export function GetAuthorityBtn(data) {
    return request({
        url: "/user/getAuthorityBtn",
        method: "post",
        data
    })
}

// 设置按钮级权限
export function SetAuthorityBtn(data) {
    return request({
        url: "/user/setAuthorityBtn",
        method: "post",
        data
    })
}

// 判断是否可以删除按钮
export function CanRemoveAuthorityBtn(data) {
    return request({
        url: "/user/canRemoveAuthorityBtn",
        method: "post",
        data
    })
}

// 修改密码
export function UpdatePassword(data) {
    return request({
        url: '/user/updatePassword',
        method: 'post',
        data
    });
}

// 获取角色ID对应的权限列表
export function GetMenuListByRoleId(data) {
    return request({
        url: '/user/getMenuInfoListByRoleId',
        method: 'post',
        data
    });
}

// 角色 - 权限绑定
export function AddRoleMenuAuth(data) {
    return request({
        url: '/user/updateRoleMenuAuth',
        method: 'post',
        data
    });
}

// 数据总览
export function DataScreening() {
    return request({
        url: '/datascreening',
        method: 'get'
    });
}

// 待办
export function GetTodoList() {
    return request({
        url: '/user/getTodoList',
        method: 'post'
    });
}

// 删除待办事件列表
export function DelTodoInfo(data) {
    return request({
        url: '/user/delTodoInfo',
        method: 'post',
        data
    });
}
